import dropdownConstants from '../../constants';
import computeClassName from '../../../../../../../utils/computeClassName';
import CCButtonClear from '../../../../Button/Clear';
import CCFormInput from '../../../Input';

const constants = Object.freeze({
  CLASSNAME_BASE: 'transition-colors duration-100 ease-linear sticky top-0',
  CLASSNAME_DROPDOWN_SIZE: {
    [dropdownConstants.SIZE_XSMALL]: 'mx-2 my-1 mb-2',
    [dropdownConstants.SIZE_SMALL]: 'mx-3 my-1.25 mb-2.5',
    [dropdownConstants.SIZE_MEDIUM]: 'mx-4 my-1.25 mb-2.5',
    [dropdownConstants.SIZE_LARGE]: 'mx-4 my-1.5 mb-3'
  }
});

function getComputedClassName(propsClassName, dropdownSize) {
  return computeClassName(propsClassName, `${constants.CLASSNAME_BASE} ${constants.CLASSNAME_DROPDOWN_SIZE[dropdownSize]}`);
}


export default function CCFormDropdownOptionsFilter(
  {
    dropdownSize,
    filterPlaceholderText = 'Filter',
    filterValue,
    filterValueOnChangeFn,
    filterValueOnClearFn,
    className = ''
  }
) {

  const computedClassName = getComputedClassName(className, dropdownSize);

  return (
    <CCFormInput className={computedClassName}
                 type="text"
                 size={dropdownSize}
                 value={filterValue}
                 changeFn={filterValueOnChangeFn}
                 placeholderText={filterPlaceholderText}
                 isInline={false}
                 rightSideComponent={
                   <CCButtonClear size={dropdownSize}
                                  clearFn={filterValueOnClearFn}
                                  isDisabled={!filterValue || !filterValue.length}
                                  className="flex-shrink-0 flex-grow-0"/>
                 }/>
  );
}
